import React from 'react';
import { Construction } from 'lucide-react';

interface ComingSoonProps {
  feature: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ feature }) => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
      <div className="text-center max-w-md px-6">
        <div className="w-24 h-24 bg-[rgba(35,244,124,0.1)] rounded-full flex items-center justify-center mx-auto mb-6">
          <Construction size={48} className="text-[#23F47C]" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-3">
          Coming Soon
        </h1>
        
        <p className="text-lg text-[#8F8F8F] mb-2">
          {feature}
        </p>
        
        <p className="text-sm text-[#5F5F5F]">
          This feature is currently under development and will be available soon.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
